import React, { ReactNode, forwardRef } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
}

const PageContent = forwardRef<HTMLDivElement, IProps>(function PageContent(
  { children },
  ref,
) {
  return <div ref={ref} className={css.page__content}>{children}</div>;
});

export default PageContent;
